// Cloud development environment — the deployed dev auth API.
// Built via the `development` angular configuration (fileReplacement of
// environment.ts). Local dev uses the base environment.ts (the `local`
// configuration); cloud production uses environment.prod.ts.
export const environment = {
  production: false,
  apiBaseUrl: 'https://auth-dev.happen.biz',
};
